import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 80 80",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.17,28.34l5.01-9.16,9.16-5.01-9.16-5.01L14.17,0l-5.01,9.16L0,14.17l9.16,5.01,5.01,9.16Zm-2.06-16.23l2.06-3.77,2.06,3.77,3.77,2.06-3.77,2.06-2.06,3.77-2.06-3.77-3.77-2.06,3.77-2.06Z",
			fill: "currentcolor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.02,48h-14v14h14v-14Zm-4,10h-6v-6h6v6Z",
			fill: "currentcolor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.05,80.02v-20.92l-5.98-4.61-4.07,3.03-3.93-3.03-2.07,1.54v-12.03h6.85l-6.83-6.83V19h-12v6.19l-12.02-12.01L9.2,44h6.8v12l-1.95-1.51-4.07,3.03-3.93-3.03L0,59v20.96H5.25l6.77,.07v-.07h1.23l2.75,.03v.02h2.02l2,.02v-.02H64v-.05h1.27l6.77,.07v-.07h1.23l6.77,.07ZM56.02,23h4v9.74l-4-4.5v-5.24Zm20.02,38.07v14.89h-4v-14.96l1.99-1.48,2.02,1.56Zm-12.02-.06l2-1.49,2,1.54v14.9h-4v-14.95ZM40,18.83l20.59,20.57,.53,.6H18.85l21.15-21.17Zm-20,25.17H60v31.95h-3.98v-23.95h-16v23.95H20.02v-16.85l-.02-.02v-15.08Zm32.02,31.95h-8v-19.95h8v19.95ZM16,61.05v14.9h-3.98v-14.96l1.99-1.48,1.99,1.54Zm-12,14.89v-14.93l2-1.49,2,1.54v14.9H4Z",
			fill: "currentcolor"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "70.83 22.17 74.07 16.24 80 13 74.07 9.76 70.83 3.83 67.59 9.76 61.66 13 67.59 16.24 70.83 22.17",
			fill: "currentcolor"
		})
	]
});
export default SvgHome;
